// extracted by mini-css-extract-plugin
module.exports = {"header":"b4_kt","header__content":"b4_kv","header__menu":"b4_kw","header__logo":"b4_kx","header__contacts":"b4_ky"};